import React from "react";
import {
  ComposedChart,
  Line,
  ResponsiveContainer,
  XAxis,
  YAxis,
} from "recharts";

import { useTheme } from "@mui/material";
import Grid from "@mui/material/Grid";

interface MobileTimeSeriesSkeletonProps {
  fakeLineData: { name: string; [key: string]: number | string }[];
}

export const MobileTimeSeriesSkeleton = ({
  fakeLineData,
}: MobileTimeSeriesSkeletonProps) => {
  const theme = useTheme();
  const grayHexCodes = [
    theme.igPrimitives.gray["A100"],
    theme.igPrimitives.gray[900],
    theme.igPrimitives.gray[800],
    theme.igPrimitives.gray[900],
    theme.igPrimitives.gray[700],
    theme.igPrimitives.gray["A100"],
    theme.igPrimitives.gray[700],
    theme.igPrimitives.gray[900],
  ];
  const lineKeys = Object.keys(fakeLineData[0]).filter((key) => key !== "name");

  return (
    <Grid>
      <ResponsiveContainer width="100%" height={240}>
        <ComposedChart
          width={500}
          height={240}
          data={fakeLineData}
          margin={{
            top: 10,
            right: 5,
            left: 0,
            bottom: 5,
          }}
        >
          <text
            className="infinite-pulsing"
            x="50%"
            y="50%"
            style={{
              fontSize: "14px",
              fill: theme.palette.text.secondary,
              lineHeight: "20px",
              letterSpacing: ".25px",
            }}
            textAnchor="middle"
          >
            Loading Data
          </text>
          <XAxis
            dataKey={"xAxisKey"}
            tickLine={false}
            tick={false}
            axisLine={{ stroke: theme.igBorders.core.disabled }}
            style={{ fontFamily: theme.typography.fontFamily, fontSize: 10 }}
            height={30}
          />
          <YAxis
            type={"number"}
            axisLine={{ stroke: theme.igBorders.core.disabled }}
            style={{ fontFamily: theme.typography.fontFamily, fontSize: 10 }}
            tickLine={false}
            tick={false}
            width={45}
          />

          {lineKeys.map((key, index) => (
            <Line
              className="infinite-pulsing"
              key={key}
              type="monotone"
              strokeWidth={2}
              dot={false}
              dataKey={key}
              stroke={index > 7 ? "gray" : grayHexCodes[index]}
              fill={index > 7 ? "gray" : grayHexCodes[index]}
            />
          ))}
        </ComposedChart>
      </ResponsiveContainer>
    </Grid>
  );
};
